"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instantiateControlComponents = exports.initializeApp = exports.bindControlComponents = void 0;

var _globals = require("@insided/shared/utils/globals");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _initialiseComponent = _interopRequireDefault(require("./initialiseComponent"));

var _bootstrap = require("@insided/shared/bootstrap");

var _initializeApp = require("@insided/destination/app/initializeApp");

var _initialiseComponent2 = _interopRequireDefault(require("@insided/destination/app/initialiseComponent"));

// eslint-disable-next-line import/no-named-as-default
var instantiateControlComponents = (0, _bootstrap.createComponentInstantiator)('[data-control]', _initialiseComponent.default, 'control');
exports.instantiateControlComponents = instantiateControlComponents;
var bindControlComponents = (0, _bootstrap.createComponentBinder)(instantiateControlComponents);
exports.bindControlComponents = bindControlComponents;

var initializeApp = function initializeApp() {
  window.insided = {
    initialiseControlComponent: _initialiseComponent.default,
    bindControlComponents: bindControlComponents,
    trackEvent: _publish.default.trackEvent,
    publish: _globals.publish,
    bindPreactComponents: _initializeApp.bindPreactComponents,
    initialiseComponent: _initialiseComponent2.default
  }; // Initialize components

  bindControlComponents(document); // Set up global publishers

  (0, _bootstrap.addGlobalPublishers)();
};

exports.initializeApp = initializeApp;